import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PermissionEnum } from '@app/core/services/administrator/models/enum/permission.enum';
import { SubscriptionStatusHistoryStateEnum } from '@app/core/services/subscription/models/enum/subscription-status-history-state.enum';
import { SubscriptionStatusesHistory } from '@app/core/services/subscription/models/subscription/subscription-status-history.model';
import { SubscriptionDTO } from '@app/core/services/subscription/models/subscription/subscription.model';
import { SubscriptionService } from '@app/core/services/subscription/subscription.service';
import { NotificationService } from '@app/core/services/util/notification.service';
import { UtilService } from '@app/core/services/util/util.service';
import { TranslateService } from '@ngx-translate/core';
import { SubscriptionStatusEnum } from '@app/core/services/subscription/models/enum/subscription-status.enum';
import { AdministratorService } from '@app/core/services/administrator/administrator.service';
import { UserAdminUI } from '@app/core/services/administrator/models/user-admin.model';

@Component({
    selector: 'ap-subscription-status-history-panel',
    templateUrl: './subscription-status-history-panel.component.html',
    styleUrl: './subscription-status-history-panel.component.css',
    standalone: false
})
export class SubscriptionStatusHistoryPanelComponent implements OnInit {

  _subscription: SubscriptionDTO;
  @Input() set subscription(subscriptionDTO: SubscriptionDTO) {
    this._subscription = subscriptionDTO;
    this.filterSubscriptionStatusesHistory();
  };

  get subscription(): SubscriptionDTO {
    return this._subscription;
  }

  @Input() canUpdateSubscriptionActive = false;
  @Input() canUpdateSubscriptionTerminated = false;

  Permissions = PermissionEnum;
  displayedColumns = ['TARGET_STATUS', 'DESIRED_APPLICATION_DATE', 'STATUS_REASONS', 'STATE', 'ERROR_DETAILS', 'ACTION'];
  statusHistoryDataSource: MatTableDataSource<SubscriptionStatusesHistory> = new MatTableDataSource<SubscriptionStatusesHistory>();
  totalElements = 0;

  constructor(
    private subscriptionService: SubscriptionService,
    private utilService: UtilService,
    private notificationService: NotificationService,
    private translateService: TranslateService,
    private administratorService: AdministratorService
  ) {}

  ngOnInit(): void {
    const loggedAgent = this.administratorService.loggedAgent$.getValue() as UserAdminUI;
    if (loggedAgent && loggedAgent.roleInfos && loggedAgent.roleInfos.permissions) {
      this.canUpdateSubscriptionActive = loggedAgent.roleInfos.permissions.includes(PermissionEnum.UPDATE_SUBSCRIPTION_ACTIVE as any);
      this.canUpdateSubscriptionTerminated = loggedAgent.roleInfos.permissions.includes(PermissionEnum.UPDATE_SUBSCRIPTION_TERMINATED as any);
    }
    this.filterSubscriptionStatusesHistory();
  }

  canShowTrashIcon(subscriptionStatusHistory: SubscriptionStatusesHistory): boolean {
    const isTargetActiveOrInactive = [SubscriptionStatusEnum.ACTIVE, SubscriptionStatusEnum.INACTIVE].includes(subscriptionStatusHistory.status as any);
    const isTargetTerminated = subscriptionStatusHistory.status === SubscriptionStatusEnum.TERMINATED as any;

    return (this.canUpdateSubscriptionActive && isTargetActiveOrInactive) ||
           (this.canUpdateSubscriptionTerminated && isTargetTerminated);
  }

  deleteSubscriptionStatusHistory(subscriptionStatusHistory: SubscriptionStatusesHistory) {
    if (!this.canShowTrashIcon(subscriptionStatusHistory)) {
        this.notificationService.notify('error', 'Unauthorized access.');
        return;
    }

    this.subscriptionService.deleteSubscriptionStatusHistory(subscriptionStatusHistory.subscriptionId, subscriptionStatusHistory.subscriptionStatusHistoryId).subscribe({
      next: () => {
        this.subscription.subscriptionStatusesHistory = this.subscription.subscriptionStatusesHistory.filter(ssh => ssh.subscriptionStatusHistoryId != subscriptionStatusHistory.subscriptionStatusHistoryId);
        this.filterSubscriptionStatusesHistory();
        this.notificationService.notify('success', this.translateService.instant('SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.STATUS_HISTORY.LIST.TOAST.DELETE.SUCCESS'))
      },
      error: _err => {
        console.error(_err);
        this.notificationService.notify('error', this.translateService.instant('SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.STATUS_HISTORY.LIST.TOAST.DELETE.ERROR'))
      }
    });
  }

  private filterSubscriptionStatusesHistory() {
    if (!this.subscription || !this.subscription.subscriptionStatusesHistory) {
      return;
    }
    let subscriptionStatusesHistoryFiltered = this.subscription.subscriptionStatusesHistory.filter(s => [SubscriptionStatusHistoryStateEnum.AWAITING, SubscriptionStatusHistoryStateEnum.ERROR].includes(s.state));
    subscriptionStatusesHistoryFiltered = subscriptionStatusesHistoryFiltered.sort((a,b) => this.utilService.compare(a.effectiveDate, b.effectiveDate, false))
    this.statusHistoryDataSource = new MatTableDataSource<SubscriptionStatusesHistory>(subscriptionStatusesHistoryFiltered);
    this.totalElements = this.statusHistoryDataSource.data.length;
  }
}
